import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=db1fb094&scoped=true&"
import script from "./Projects.vue?vue&type=script&lang=js&"
export * from "./Projects.vue?vue&type=script&lang=js&"
import style0 from "./Projects.vue?vue&type=style&index=0&id=db1fb094&prod&scoped=true&lang=css&"
import style1 from "./Projects.vue?vue&type=style&index=1&id=db1fb094&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1fb094",
  null
  
)

export default component.exports